import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import Button, { ButtonType, ButtonTheme } from '../../atoms/button/button';
import './formStatus.scss';
import Label from '../../atoms/label/label';
import swal from 'sweetalert';
import { httpPost} from '../../../store/externalCalls/httpCalls';
import { isArray } from 'lodash';


const FormStatus = (props) => {
  const {
    value, info, colors, onChange,onChangeRow,label,helpText,tooltipPosition,buttonText,valueButton,textAreYouSure,actionUrl,relatedId,button,small,refreshRowOnChange
  } = props;

  const [isActive, setActiveButton] = useState(true);

  let statusIndex = value;
  if (value.indexOf(' ') !== -1) {
    statusIndex = value.substring(0, value.indexOf(' '));
  }
  if (value.indexOf('-') !== -1) {
    statusIndex = value.substring(0, value.indexOf('-'));
  }

  const handlerClick = () => {
    onChange({ name: 'status', newValue: 'status' });
    setActiveButton(!isActive);
  };

  const handlerCustomClick= ()=>{
    swal({
      title: 'Are you sure?',
      text: textAreYouSure,
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((ok) => {
      if(ok){
        let params={'id':relatedId};
        httpPost(actionUrl, params).then((res)=>{
          if(refreshRowOnChange){
            onChangeRow({ target: { value:res.message } });
          }else
            window.location.reload();
        }).catch(e=>{
          if(e.errors){
            swal('Error', e.errors.error[0], 'error');
          }
        });
      }
    });
  }
  const reconfirmCustom=(actionUrl,params)=>{
    swal({
      title: 'CAUTION!',
      text: button.reconfirmMessage,
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((ok) => {
      if(ok){
        httpPost(actionUrl, params).then((res)=>{
          if(res.status=="ok")
            // console.log("yes");
            return;
            // window.location.reload();
        }).catch(e=>{
          if(e.errors){
            swal('Error', e.errors.live[0], 'error');
          }
        });
      }
    });
  }

  const handlerCustomClick2= ()=>{
    let id="";
    let location=window.location.pathname;
    let locationArr = location.split("/");
    id=locationArr[locationArr.length-1];
    swal({
      title: 'CAUTION!',
      text: button.confirmMessage,
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((ok) => {
      if(ok){
        let params={'id':id};
        reconfirmCustom(button.actionUrl,params);
      }
    });
  }
  useEffect(() => {
    setActiveButton(value === 'error-retry');
  }, [value]);
  const checkContent=(info)=>{
    if(Array.isArray(info))
      return (<div>
        {info.map((el)=>{
          return <div>{el}</div>
        })}
      </div>);
    else
      return info;
  }
  return (
    <OverlayTrigger
      trigger={['hover', 'focus', 'click']}
      placement={(tooltipPosition?tooltipPosition:"left")}
      overlay={(
        <Popover id="tooltip-left">
          <Popover.Content>
            {checkContent(info)}
          </Popover.Content>
        </Popover>
      )}
    >
      <div className="form-status__general">
        {label &&  label !== ''
        && (
          <Label>{label}</Label>
        )}
        <Button type={ButtonType.BUTTON} theme={ButtonTheme.LIGH} className={(small==true?`form-status__align-center`:'')}>
          <span className={`form-status__dot ${colors[statusIndex]}`} />
          {small==true && <div>{value === 'error-retry' ? 'error' : value}</div>}
          {!small && <span>{value === 'error-retry' ? 'error' : value}</span>}
        </Button>
        {value === 'error-retry' && (
        <div>
          <Button
            type={ButtonType.BUTTON}
            theme={ButtonTheme.ERROR_OUTLINE}
            disabled={!isActive}
            onClick={handlerClick}
          >
            Retry
          </Button>
        </div>
        ) }
        {valueButton && (value === valueButton || (isArray(valueButton) && valueButton.includes(value))) && (
          
        <div>
          <Button
            type={ButtonType.BUTTON}
            theme={ButtonTheme.ERROR_OUTLINE}
            onClick={handlerCustomClick}
          >
            {buttonText}
          </Button>
        </div>
        ) }
        {button && 
          <Button
            type={ButtonType.BUTTON}
            theme={ButtonTheme.ERROR_OUTLINE}
            onClick={handlerCustomClick2}
          >
            {button.title}
          </Button>
        }
      </div>
    </OverlayTrigger>

  );
};

FormStatus.propTypes = {
  value: PropTypes.string,
  info: PropTypes.string,
  colors: PropTypes.shape({}),
  onChange: PropTypes.func,
};

FormStatus.defaultProps = {
  value: '',
  info: 'No info',
  colors: undefined,
  onChange: () => {},
};

export default FormStatus;
